import {AuthI18n} from '@/locales/base.message.locales';

export const auth: AuthI18n = {
  titles: {
    login: 'Entrar',
    welcome: 'Bem-vindo à liga',
    join_the_league: 'Faça parte da liga',
    login_with_facebook: 'Facebook',
    login_with_google: 'Google',
    create_account: 'Crie a sua conta para começarmos',
    or_sign_in_with: 'OU ENTRE COM',
    forget_password_question: 'Esqueceu sua senha?',
    forget_password: 'Não tem problema, vamos consertar isso',
    change_password: 'Agora nós iremos trocar a sua senha',
    account_already_validated: 'A sua conta ja foi validada',
    account_has_validated: 'Conta validada com sucesso!',
    account_has_not_validated: 'Não foi possível validar sua conta, tente novamente!',
    validation_account: 'Validando sua conta ...',
    request_confirmation_email: 'Reenviar email de validação de conta',
    accept_terms_of_use: ' termos e condições',
    accept_t: 'Aceito os',
    accept_p: 'Aceito as',
    accept_privacy_policy: ' políticas de privacidade',
    almost_there: 'Estamos quase lá!',
    complete_registration: 'Para concluir o seu cadastro na plataforma, declare abaixo que aceita os termos de uso assim com as políticas de privacidade.'
  },
  subtitle: {
    sent_confirmation_email: 'Enviamos um link de confirmação para o seu email.',
    forget_password: 'Por favor, forneça seu email',
    change_password: 'Por favor, informe uma nova senha e confirme ela',
  },
  buttons: {
    complete_profile: 'Completar meu perfil',
    join_the_league: 'Venha para a Liga',
    lost_password: 'Esqueceu a sua senha ?',
    new_user: 'Novo cadastro',
    remember_be: 'Lembre-me',
    recover_password: 'Recupere minha senha',
    change_password: 'Atualizar senha',
    create_account: 'Criar conta',
    create: 'Criar',
  },
  message: {
    forgot_email_not_found: 'Desculpe, não encontramos seu endereço de e-mail',
    forgot_email_send: 'Enviamos um email para você com um link de recuperação',
    token_expiration: 'Sinto muito, mas parece que seu link esta expirado ou invalido, por favor solicite um link novo',
    password_has_changed: 'Senha atualizada com sucesso',
    credentials_has_updated: 'Credenciais atualizadas com sucesso',
    credentials_not_updated: 'Ops.. falhou para atualziar suas credenciais, por favor tente novamente mais tarde',

  },
};
